import { render, staticRenderFns } from "./taskTypeDespatchStockSelect.vue?vue&type=template&id=54827e38&"
import script from "./taskTypeDespatchStockSelect.vue?vue&type=script&lang=js&"
export * from "./taskTypeDespatchStockSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports